import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './about.module.css';

export function AboutHero() {
  return (
    <SectionWrapper
      background="white"
      className={styles.heroSection}
      contentClassName={styles.heroContent}
      data-testid="about-section-hero"
    >
      <div className={styles.heroCopy}>
        <p className={styles.heroEyebrow}>— ABOUT KUDU</p>
        <h1 className={styles.heroTitle}>
          Founded in a UCLA classroom. Used at{' '}
          <em>research universities</em> ever since.
        </h1>
        <p className={styles.heroSubhead}>
          Kudu was built by two academics who wanted courseware that fit the
          courses they actually teach. A decade later, it serves tens of
          thousands of students across UCLA, UC San Diego, San Diego State, and
          other research universities — and is still built by the people who
          teach with it.
        </p>
      </div>
    </SectionWrapper>
  );
}
